import { render, staticRenderFns } from "./MaiJiaCaseDetail.vue?vue&type=template&id=4f7bfb2e&scoped=true&"
import script from "./MaiJiaCaseDetail.vue?vue&type=script&lang=js&"
export * from "./MaiJiaCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./MaiJiaCaseDetail.vue?vue&type=style&index=0&id=4f7bfb2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7bfb2e",
  null
  
)

export default component.exports